/**
 * Common constant mappings used across multiple apps
 * These define the relationship between string values and numeric API values
 */

// ============================================================================
// Dropdown Options Mapping
// ============================================================================

import type { DropdownOption } from '../components/UserDropdown';

export const SUPPORT_TYPES: DropdownOption[] = [
  { value: 1, label: 'Pinned - Pinned' },
  { value: 2, label: 'Fixed - Fixed' },
  { value: 3, label: 'Fixed - Free' },
  { value: 4, label: 'Free - Fixed' },
  { value: 5, label: 'Fix - Pinned' },
  { value: 6, label: 'Pinned - Fix' }
];

export const SUPPORT_TYPES_STEEL_PLATE: DropdownOption[] = [
  { value: 1, label: 'Pinned All Around' },
  { value: 2, label: 'Fixed All Around' }
];

export const ORIENTATION_TYPES: DropdownOption[] = [
  { value: 0, label: 'Vertical' },
  { value: 1, label: 'Horizontal' }
];

export const DIRECTION_TYPES: DropdownOption[] = [
  { value: 0, label: 'Major' },
  { value: 1, label: 'Minor' }
];

export const RESTRAINT_TYPES: DropdownOption[] = [
  { value: 0, label: 'Unrestrained' },
  { value: 1, label: 'Restrained' }
];

export const DIF_TYPES: DropdownOption[] = [
  { value: 0, label: 'Far Range' },
  { value: 1, label: 'Close In' },
  { value: 2, label: 'Ones' }
];

// ============================================================================
// URL VALUE MAPPINGS
// ============================================================================

/**
 * Value mappings for URL params (e.g., '0' -> 'pin-pin')
 * Used when parsing URL parameters to convert numeric values back to strings
 */
export const URL_VALUE_MAPS: Record<string, Record<string, string>> = {
  supports: {
    '1': 'pin-pin',
    '2': 'fix-fix',
    '3': 'fix-free',
    '4': 'free-fix',
    '5': 'fix-pin',
    '6': 'pin-fix'
  },
  orientation: {
    '0': 'Vertical',
    '1': 'Horizontal'
  },
  restrained: {
    '0': 'Unrestrained',
    '1': 'Restrained'
  },
  direction: {
    '0': 'Major',
    '1': 'Minor'
  },
  dif: {
    '0': 'Far Range',
    '1': 'Close In',
    '2': 'Ones'
  },
  sectionType: {
    '0': 'Rectangular',
    '1': 'Circular',
    '2': 'Tee'
  },
  supportsSteelPlate: {
    '1': 'Pinned All Around',
    '2': 'Fixed All Around'
  }
};
